import React from "react"
import * as style from './filterwrap.module.scss'
import iconBlack from '../images/icons/filter-black.svg'
import iconWhite from '../images/icons/filter.svg'

const FilterWrap = ({ children, theme }) => {
  const icon = theme === 'dark' ? iconWhite : iconBlack
  return (
    <div className={style.wrapSelect}>
      <img src={icon} className="hidden-desktop" alt="" />
      {children}
    </div>
  )
}

export default FilterWrap
